import { NodeObject } from "./common/ah.mb.common.node-object";
import { ModelNotifier } from "./model-notifier";
import { IBasicCommandResponse } from "./ah.mb.client-notifications";
import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import { IMultiSelectItem } from "../infrastructure/multi-select-item";

export class DirectoryServices {

    // Private declarations
    private rootApiUrl = "/api/1.0";
    private directoryApiUrl = this.rootApiUrl + "/directory";
    private createModelApiUrl = this.directoryApiUrl;
    private deleteObjectUrl = this.directoryApiUrl + "/delete";
    private uploadModelApiUrl = this.directoryApiUrl + "/uploadmodel";
    private downloadObjectUrl = this.directoryApiUrl + "/download";
    private editModelPropsApiUrl = this.directoryApiUrl + "/editprops";
    private lockModelUrl = this.directoryApiUrl + "/lock";
    private unlockModelUrl = this.directoryApiUrl + "/unlock";

    private readonly modelNotifier: ModelNotifier;

    /**
     * Ctor
     * @param clientNotifier 
     * @param modelObservable 
     * @returns {} 
     */
    constructor(modelNotifier: ModelNotifier) {
        this.modelNotifier = modelNotifier;

    }

    // Creates a new model
    createModel = (name,
        description,
        category,
        logCommands,
        modelTreePath: string): Promise<IBasicCommandResponse> => {

        var payload = {
            modelName: name,
            description: description,
            category: category,
            commandLoggingEnabled: logCommands,
            parentFolder: modelTreePath
        };

        var request = {
            method: "POST",
            body: JSON.stringify(payload),
            headers: new Headers({
                'Accept': "application/json",
                'Content-Type': "application/json",
            })

            //                contentType: "application/json",
            //              dataType: "json",
            //                url: this.createModelApiUrl
        };

        return FetchWrapper.sendCommandAndHandle(this.createModelApiUrl, request)
            .then((data => {
                if (data.success) {
                    const nodeInfo = new NodeObject(modelTreePath + "\\" + name, "DirectoryModelNode", false, name);
                    this.modelNotifier.notifyNodeCreated(nodeInfo, {});
                }
                return data;
            }));
    }

    // Save commands function, to save model changes
    uploadModel = (formData, name, desc, category, parentPath: string): Promise<any> => {

        formData.append("name", name);
        formData.append("description", desc);
        formData.append("category", category);
        formData.append("parentPath", parentPath);

        var url = this.uploadModelApiUrl; // + '?name=' + name + '&description=' + desc + '&category=' + category + '&visibility=' + visibility;
        // url = encodeURI(url);

        var request = {
            // url: url,
            //                    type: "POST",
            data: formData,
            //                cache: false,
            //    contentType: false,
            //  processData: false,
            method: "post",
            //headers: {
            //    'Content-Type': 'multipart/form-data'
            //}
        };

        return FetchWrapper.fetch(url, request)
            .then(response => {
                return response.json();
            })
            //            $.post()
            .then((data => {
                if (data.success) {
                    const nodeInfo = new NodeObject(parentPath + "\\" + name, "DirectoryModelNode", false, name);
                    this.modelNotifier.notifyNodeCreated(nodeInfo, {});
                }
                return data;
            }));
    }


    // Delete object function
    deleteObject = (objectId: string, parentPath: string, promise: JQueryDeferred<any>) => {

        var payload = { objectId: objectId };

        var request = {
            method: "POST",
            data: JSON.stringify(payload),
            //                contentType: "application/json",
            //              url: this.deleteObjectUrl
        }

        FetchWrapper.typedFetch<IBasicCommandResponse>(this.deleteObjectUrl, request)
            .then(response => response.json())
            .then((response => {
                if (response.success) {
                    const nodeInfo = new NodeObject(parentPath + "\\" + objectId, "DirectoryModelNode", false, objectId);
                    this.modelNotifier.notifyNodesDeleted([nodeInfo]);
                }
                promise.resolve(objectId, response);

            }));
    }

    // Download object function
    downloadModel(objectId: string, scenarioNames: string[]) {
        const myUrlWithParams = new URL(this.downloadObjectUrl, document.location.href);

        myUrlWithParams.searchParams.append("objectId", objectId);

        // Only json is now supported
        myUrlWithParams.searchParams.append("exportFormat", "json");

        scenarioNames.forEach(name => myUrlWithParams.searchParams.append("scenarioNames", name));
        window.location.href = myUrlWithParams.href;
    }

    /**
     * Edit model properties
     */
    editModelProps = (modelId, name, description, category, logCommands, parentFolder): Promise<IBasicCommandResponse> => {

        var payload = {
            modelId: modelId,
            name: name,
            description: description,
            category: category,
            commandLoggingEnabled: logCommands
        };

        var request = {
            method: "POST",
            body: JSON.stringify(payload),
        };


        return FetchWrapper.sendCommandAndHandle(this.editModelPropsApiUrl, request)
            //     $.ajax(request)
            .then((response => {
                if (name !== modelId && response.success)
                    this.modelNotifier.notifyNodeRenamed(parentFolder + "\\" + modelId, name);
                return response;
            }));
    }

    // Delete object function
    lockModel = (modelId: string): Promise<IBasicCommandResponse> => {

        return FetchWrapper.sendCommandAndHandle(
            this.lockModelUrl,
            {
                method: "post",
                body: JSON.stringify({ modelId: modelId })
            });
    }

    // Delete object function
    unlockModel = (modelId: string): Promise<IBasicCommandResponse> => {

        return FetchWrapper.sendCommandAndHandle(
            this.unlockModelUrl,
            {
                method: "post",
                body: JSON.stringify({ modelId: modelId })
            });

    }
}





// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.ui.directory-services.ts